import imgOutside from '../../assets/buildings/house/outside.jpg';
import { Building } from '../../interfaces/buildings';

const ksbTeamConfig: Building = {
    img: imgOutside
}

export default ksbTeamConfig;